import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  MARKETING_FETCH,
  UPDATE_FEATURE,
  M_POST,
  M_GET,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'marketing' })
export default class Marketing extends VuexModule {
  @Action
  async Fetch() {
    return Vue.axios({
      url: BASE_URL + MARKETING_FETCH,
      data: '',
      method: M_GET,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  async FeatureUpdate(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_FEATURE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
